import { FeatureFlag } from '../FeatureFlag';

export const useAlphaLensSpeedupQuery = new FeatureFlag({
    key: 'use-alpha-lens-speedup-query',
    defaultValue: false,
});
